module.exports = __webpack_public_path__ + "static/img/book23.bca6056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book23.jpg
// module id = R8ba
// module chunks = 1